import { Component, Inject, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, FormControlName, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DateFilterTypes } from 'app/modules/common/enums/date-filter-enums';
import { DateHelper } from 'app/modules/common/helpers/DateHelper';
import { SubscriptionContainer } from 'app/modules/common/helpers/SubscriptionsContainer';
import { SharedService } from 'app/modules/common/services/shared-service';
import { SendingService } from 'app/modules/fuse/services/sending.service';

@Component({
    selector: 'app-task-elimination-popup',
    templateUrl: './task-elimination-popup.component.html',
    styleUrls: ['./task-elimination-popup.component.scss'],
    standalone: false
})
export class TaskEliminationPopupComponent implements OnInit {
    @ViewChild('medicoSelect')doctorSearchInput :ElementRef
    _medicoList :any=[];
    DateFilterType = DateFilterTypes;

    private subs: SubscriptionContainer;
    public allDoctors = [];
    public admintrativeUsers = [];
    public hideElMedicoInput = false;
    public hideNotificadasDateField = false;
    public SelectedDoctor;    
    public SelectedAdministrativeUser: any;
    public taskEliminationForm: UntypedFormGroup;
    public IsCancelDissabled:boolean=false;

    constructor(
        private _dialogRef: MatDialogRef<TaskEliminationPopupComponent>,
        private _sharedService: SharedService,
        private _sendingService: SendingService,
        public _fb: UntypedFormBuilder,
        @Inject(MAT_DIALOG_DATA) private users
        ) {         
            this.allDoctors = users.medicos
            this.admintrativeUsers = users.admintrativeUsers
            this._medicoList=users.medicos
        }

    ngOnInit(): void {
        this._sendingService.selectedCompanyId = localStorage.getItem('Empresa');
        this.createNotificationForm();       
        this.hideElMedicoInput = false;
        this.hideNotificadasDateField = false;
    }
    SearchDoctors()
    {
      const searchInput=this.doctorSearchInput.nativeElement.value ?
        this.doctorSearchInput.nativeElement.value.toLowerCase():'';
  
      this._medicoList =this.allDoctors.filter(m=>{
        if(m.nombre!=null)
        {
            const viewValue : string=m.nombre.toLowerCase();
            return viewValue.indexOf(searchInput) > -1;
        }
      })
    }

    createNotificationForm() {
        this.taskEliminationForm = this._fb.group({
            Enviar: ["all"],
            Tareas: ["PendientesDeNotificarEliminacion"],
            SelectedDoctor: [''],
            SelectedAdministrativeUser: [''],
            DateFrom: [''],
            DateTo: [''],
            SelectedCompanyId: [this._sendingService.selectedCompanyId]
        });
    }

    public getFormControl(formControlName: string): UntypedFormControl {
        return this.taskEliminationForm.get(formControlName) as UntypedFormControl;
    }

    public onDoctorChange(event: any) {
        this.SelectedDoctor = event.value;
        this._medicoList=this.allDoctors;
        setTimeout(() => {
          this.doctorSearchInput.nativeElement.value=null;
        }, 1000);
    }

    public onAdminUserChange(event: any) {
        this.SelectedAdministrativeUser = event.value;
        
    
    }

    public enviarChangeHandler(e): void {
        if ("single" === e.target.value) {
            this.hideElMedicoInput = true;
            this.taskEliminationForm.get('SelectedDoctor').setValidators([Validators.required]);
            this.taskEliminationForm.get('SelectedDoctor').untouched;
            this.taskEliminationForm.updateValueAndValidity();
        } else {
            this.hideElMedicoInput = false;
            this.taskEliminationForm.get('SelectedDoctor').clearValidators();
            this.taskEliminationForm.get('SelectedDoctor').reset();
            this.taskEliminationForm.get('SelectedDoctor').untouched;
            this.taskEliminationForm.get('SelectedDoctor').valid;
            this.taskEliminationForm.updateValueAndValidity();
        }
    }

    public tareasChangeHandler(e): void {
        if ("Notificadas" === e.target.value) {
            this.hideNotificadasDateField = true;
            this.taskEliminationForm.get('DateFrom').setValidators([Validators.required]);
            this.taskEliminationForm.get('DateFrom').untouched;
            this.taskEliminationForm.get('DateTo').setValidators([Validators.required]);
            this.taskEliminationForm.get('DateTo').untouched;
            this.taskEliminationForm.updateValueAndValidity();
        } else {
            this.hideNotificadasDateField = false;
            this.taskEliminationForm.get('DateFrom').clearValidators();
            this.taskEliminationForm.get('DateFrom').reset();
            this.taskEliminationForm.get('DateFrom').untouched;
            this.taskEliminationForm.get('DateFrom').valid;
            this.taskEliminationForm.get('DateTo').clearValidators();
            this.taskEliminationForm.get('DateTo').reset();
            this.taskEliminationForm.get('DateTo').untouched;
            this.taskEliminationForm.get('DateTo').valid;
            this.taskEliminationForm.updateValueAndValidity();
        }
    }



    public setFilterValues(filterType: string, data: Date = null): void {
        switch (filterType) {
            case 'commonDateFrom':
                this.taskEliminationForm.patchValue({ DateFrom: DateHelper.getUTCDateString(data) });
                break;
            case 'commonDateTo':
                this.taskEliminationForm.patchValue({ DateTo: DateHelper.getUTCDateString(data) });
                break;
            default:
                break;
        }
    }

    onSubmit(): void {
        this.taskEliminationForm.markAllAsTouched();
        if (this.taskEliminationForm.valid) {
            this.IsCancelDissabled=true;
            console.log(this.taskEliminationForm.value);
            this._sendingService.NotificationTareasEliminadas(this.taskEliminationForm.value).subscribe(res => {
                if (res.code === 0) {
                    console.log(res);
                    this.close();
                    this._sharedService.ShowSnackBar(res.result);
                    this.IsCancelDissabled=false;
                } else {
                    this.close();
                    this._sharedService.ShowSnackBar('API Se produjo un error');
                    this.IsCancelDissabled=false;
                }
            }, error => {
                this.close();
                this._sharedService.ShowSnackBar('API Se produjo un error');
                this.IsCancelDissabled=false;
                console.error(error);
            });

           
        }
    }

    public close(): void {
        this._dialogRef.close();
    }

}
